module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('span', {
    staticClass: "gray"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("HAPTER")]), _vm._v(" 1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('strong', [_vm._v("The Ritual: Custom and Chaos")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "drop_cap"
  }, [_c('img', {
    attrs: {
      "alt": "pg13_01",
      "src": "images/0508_pg13_01.jpg"
    }
  })]), _vm._v("etween 1814 and 1834, a total of 4,731 people were sentenced to be hanged for burglary. Those who were actually executed numbered only 233. In murder charges, the ratio was 311 hanged from 359 sentenced to hang. These figures tell us a great deal about the real use and application of the ultimate punishment. The figures exclude treason and high treason and in those cases the sentences were carried out in all but a few instances. What happened in many cases was that the royal pardon was quite often exercised, with the system of the recorders’ reports being gone through at meetings, sorting out those who should die for murder. Other reprieves or pardons in that period would have been rare.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Drawing of a hanging in the Anglo Saxon period")]), _vm._v(". "), _c('span', {
    staticClass: "smallcap2"
  }, [_c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "pg13_02",
      "src": "images/0508_pg13_02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the first few decades of the period covered here, the office of Home Secretary was not the focus for pardons; Robert Peel began to change all that when he sometimes openly challenged and negated pardons given by the King. In murders, there is no doubt that most hanged and that crime and punishment give us the established media image of the hanging. The process of a murder hunt, capture and trial gradually became a major literary and cultural narrative as the popular press developed.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("The drama is there in a natural structure of emotionally charged events:")]), _vm._v(" "), _c('ol', {
    staticClass: "list"
  }, [_c('li', [_vm._v("The murder itself and circumstances around it.")]), _vm._v(" "), _c('li', [_vm._v("The pursuit of the killer.")]), _vm._v(" "), _c('li', [_vm._v("The arrest and imprisonment.")]), _vm._v(" "), _c('li', [_vm._v("The trial.")]), _vm._v(" "), _c('li', [_vm._v("The execution.")]), _vm._v(" "), _c('li', [_vm._v("The moral or religious statement/penitence.")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In the eighteenth century and earlier, the ordinaries (gaolers) of Newgate would take down the condemned person’s biographical statements and an account of the crime in question. Then came the stories of "), _c('em', [_vm._v("The Newgate Calendar")]), _vm._v(", first published in 1773 and reprinted and enlarged through to 1826, establishing the scaffold literature and the more generally understood hangman tales that gave the public its knowledge of the ‘narrative of the noose’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A typical hanging in the years before the changing attitudes of the mid-Victorian years is the execution of James Waller, who had shot and killed the gamekeeper at Hawkesworth Hall in Bingley in 1862. One report, written in 1890, is structured in the usual manner: the crime is summarised, then ‘the confession of the culprit’ and finally his death. If we break down the ritual of Waller’s hanging, we have this sequence of events: the atmosphere and the crowd/feeling of expectancy; religious persons then distributed tracts, seeing an opportune moment to reflect on death; the Under-Sheriff then arrived to formally demand the body of Waller and he was pinioned; after that a line of dignitaries and officials stepped into place. The pen-ultimate action was either repentance or defiance. Waller chose the former: ‘Before the execution, he fell upon his knees whilst the prayers were read, and he responded to the Lord’s Prayer in the most earnest manner.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final act was of course the culprit’s submission to his fate. This is where the nature of the hangman came into play. Swiftness and humanity were called for as a general rule of course, but at that time hanging was not an exact art: ‘His struggles were rather severe, but life was extinct in less than a couple of minutes.’ After that, the dead man would either be interred within the precincts of York Castle or, as in the case of the Leeds poisoner, Mary Bateman, the corpse was sent to an infirmary for use in dis-section. The body would usually be quicklimed as well, to aid the process of decomposition.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg15_01",
      "src": "images/0508_pg15_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Home Office directions for the process of capital punisment, 1902.")]), _vm._v(" HMSO")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg16_01",
      "src": "images/0508_pg16_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Mary Evans, hanged at york, 1799. York Art Gallary")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Above and beyond that ritual sequence there were several other elements. In later times, a bell had to be sounded and sometimes there were other local indications of death. But then there was the public spectacle, and this led to the sheer chaos and barbarity of the hanging before 1868, when convicts died in the confines of prison grounds. We have a clear indication of what kinds of behaviour were common in the words used in an Act of Council dated 1737. In this edict, the authorities state that punishment awaits those who ‘throw dung and other garbage at the officers of the law, city-guard or common executioner’. They are threatened with being whipped through the city ‘by the hand of the common executioner’. Here we have a detail of one of the other duties sometimes performed by the hangman. He was, in the days before Victoria’s reign, someone who would administer other forms of physical punishment when needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The riots and violence at executions could be extremely dangerous and take place on a large scale. In many cases, the trouble was started by the actions of the reckless, abandoned types who were aggressively defiant on the scaffold, showing the type of behaviour Robert Burns writes of in his song, "), _c('em', [_vm._v("MacPherson’s Farewell:")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg17_01",
      "src": "images/0508_pg17_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("An execution at Tyburn, York, 1799.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sae rantingly, sae wantonly,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sae dauntingly gae’d he.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He played a tune and he danced it around")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All abone the gallows tree.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("An execution at the New Drop.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "pg17_02",
      "src": "images/0508_pg17_02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg18_01",
      "src": "images/0508_pg18_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Three-Legged Mare of York where Turpid died.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The sheer scale of the public spectacle and excitement of a public hanging beggars belief. On the day of the hanging, any inns and hostelries near the gallows and scaffold would prepare for a massive crowd of customers, the more wealthy paying extra for the best seats in the place, those spots having a clear view of the gallows. Fights and brawls were common, and of course these occasions were potentially very profitable affairs for local tradespeople, from fruit-sellers to prostitutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an article written in 1840, when hangings were still public, one journalist recalled the execution of Lord Ferrers, executed in 1760 for murdering his steward. The whole affair was a farce, with the two hangmen fighting for ownership of the rope (it could be sold for a handsome profit) and a massive crowd having a real influence on events. As the writer of 1840 noted: ‘When they came to Tyburn, his coach was detained some minutes by the conflux of people.’ Then, there was the pressure to make a speech and indulge in some public contrition. Ferrers was severely pressured to do this by a clergyman, who told him that ‘the world will expect some satisfaction’. In other words, the condemned person was expected to be something of a star on his or her ‘big day’ and indulge in some rhetoric. Ferrers replied: ‘Sir, what have I to do with the world?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crowd also stopped Ferrers’ procession of officials and hangmen en route as the aristocrat had asked for a drink. The sheriff was frightened at the thought of the crowd should his "), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("charge be allowed to stop; he said: ‘Your Lordship is sensible of the great influence of the crowd: we must draw up at some tavern and the conflux would be so great that it would delay the expedition which your Lordship seems to desire.’ Ferrers settled for a plug of tobacco instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to all this, there is also the material associated with the hangman’s skills (or lack of them). Two York hangmen, Curry and Askern, had difficulties with drink and with the essential alacrity required in despatching their charges into death. Central to the profession was the knowledge of the knotting needed and the length of the drop. Before the more enlightened times brought on by Marwood of Horncastle in the 1870s, there was a steady realisation that established practice was barbarous. England had been hanging people since the fifth century, and in most cases the victim had to have his legs pulled by the hangmen or by waiting family members, to hasten death.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Plan of York Castle Prison.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "pg19_01",
      "src": "images/0508_pg19_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg20_01",
      "src": "images/0508_pg20_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Plan of York Castle Assize Courts.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("This was because knotting was done rather casually and with no knowledge of the essential anatomy involved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With hindsight, and with modern sensibilities, it is hard to understand why it took so long for authorities to exercise their minds with regard to the nature of body weight and length of the drop, as well as attention given to the placing of the knot. Hangmen since Marwood have all been aware of those factors: the acceleration of the fall due to gravity, bodyweight and also what the knot actually causes to happen on the vertebrae. We know now that the knot, the drop and the downward momentum cause a rupture of the spinal cord and that the actual force of impact on the falling body’s neck is around 2,000 lb of force.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The placing of the knot under the left side of the jaw was also crucially important. There were several examples of things going wrong in that context. In Liverpool in 1883, Henry Dutton killed his wife’s grandmother and was sentenced to hang. Yorkshireman Batholomew Binns arrived to do the job, and it turned out to be one of the worst botched executions in the records. Binns had been assistant to Marwood but had not learned well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dutton’s final walk to his death was in line with regulations; but the drama started when Binns did the final pinioning and strapping ready for the lever to be pulled. The clock for eight had not struck and Binns walked to look at his victim, causing a rather nervous atmosphere. Dutton asked Lord Jesus to receive his soul, the clock struck eight and the lever was pulled. Dutton dropped but it was not a quick death. The doctor looked down at the struggling man, who was doing the ‘gallows dance’ and said: ‘This is poor work, he is not yet dead.’ In a drop of almost seven and a half feet, the body spun and the man did not die for several minutes. It was outrageously cruel by any standards. The doctor could see what the problem was: a very thick rope had been used (like a ship’s hawser, the doctor said) and Dutton was very short, only five feet two inches. The result was what every hangman feared: slow strangulation rather than a snapping of the spinal column with speed.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg21_01",
      "src": "images/0508_pg21_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Marwood, still figuring in Lincoln Castle entertainment.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg22_01",
      "src": "images/0508_pg22_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("William Marwood")]), _vm._v(". "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Laura Carter")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William Marwood studied the subject of hanging for some time before taking up the official post. When he did become the hangman for the land he executed around 350 people; before taking up that post, he practised by using a trapdoor of the hoist of a warehouse on Wharf Road, Horncastle, to perfect what became known as ‘the long drop.’ We know about his theoretical thinking that underpinned his success with a noose, largely because he wrote letters to various people, including these words from a letter written in 1879, explaining his expertise (the spelling is as he wrote):")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("In reply to your letter … I will give you a Compleat Staitment for executing the prisoner. 1 – Place pinion the prisoner round the Boadey and trems [tremendously] tight. 2 – Place bair the neck. 3 place – take the prisoner to the drop. 4 place – place the prisoner beneath the beam and stand direct from top of beam. 5 place – strap the prisoner’s leggs tight. [sic] 6 place – putt on the cap. 7 place – put on the rope round the neck tight. 8 Let the cap be down in front 9 place executioner to go direct quick to the leaver. Let down the trapdoors quick.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg23_01",
      "src": "images/0508_pg23_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("John Howard, the prison reformer")]), _vm._v(". "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The customary process of hanging, handed down from sheer raw experience, was the order of the day before this. The motivations of hangmen were initially survival, as was the case with Askern of York, a man turned hangman from convict. But in earlier years, before 1800, it was not always the hangman who did the work throughout the county. Some towns would control the execution of offenders in their own way; manors and abbots could also assume that responsibility. In some places, it would be the town bailiff who would assume the hangman’s role. The traditions were unnecessarily barbaric, and not only in the hanging itself. John Howard, the prisoner reformer, wrote in his classic work, "), _c('em', [_vm._v("The State of the Prisons")]), _vm._v(" (1777) about the related custom of ‘thumbing’ – another role of the hangman: ‘Here I cannot forebear mentioning a practice which probably had its origins from the ancient mode of torture, though now it seems only a matter of form. When prisoners capitally charged are brought up to receive sentence… the executioner slips a whipcord noose about their thumbs…’")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('img', {
    attrs: {
      "alt": "pg24_01",
      "src": "images/0508_pg24_01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Cobb Hall, where hangings in Lincoln took place.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcap2"
  }, [_vm._v("Author’s collection")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v("Details such as this point to the persistence of medieval or Saxon customs in hangings, both metropolitan and provincial. The Yorkshire hangmen were to prove a particular breed, sometimes very much influenced by such customs, and often rather darkly enjoying the publicity involved in their work.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01dc0d0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch001.vue
// module id = 75
// module chunks = 0